import _defineProperty from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { intersectionAreaPath, scaleSolution, venn } from './utils/venn';
/**
 * Layout venn data, get the path string for each set.
 */
export var Venn = function Venn(options) {
  var _options$sets = options.sets,
    sets = _options$sets === void 0 ? 'sets' : _options$sets,
    _options$size = options.size,
    size = _options$size === void 0 ? 'size' : _options$size,
    _options$as = options.as,
    as = _options$as === void 0 ? ['key', 'path'] : _options$as,
    _options$padding = options.padding,
    padding = _options$padding === void 0 ? 0 : _options$padding;
  var _as = _slicedToArray(as, 2),
    key = _as[0],
    path = _as[1];
  return function (data) {
    // Transform the data, venn layout use `sets` and `size` field.
    var vennData = data.map(function (d) {
      return Object.assign(Object.assign({}, d), _defineProperty({
        sets: d[sets],
        size: d[size]
      }, key, d.sets.join('&')));
    });
    // Sort data, avoid data occlusion.
    vennData.sort(function (a, b) {
      return a.sets.length - b.sets.length;
    });
    // Layout venn data.
    var solution = venn(vennData);
    var circles;
    return vennData.map(function (datum) {
      var setsValue = datum[sets];
      var pathFunc = function pathFunc(_ref) {
        var width = _ref.width,
          height = _ref.height;
        circles = circles ? circles : scaleSolution(solution, width, height, padding);
        var setCircles = setsValue.map(function (set) {
          return circles[set];
        });
        var p = intersectionAreaPath(setCircles);
        // Close the path for event picker.
        if (!/[zZ]$/.test(p)) p += ' Z';
        return p;
      };
      return Object.assign(Object.assign({}, datum), _defineProperty({}, path, pathFunc));
    });
  };
};
Venn.props = {};